import React from 'react';
import PropTypes from 'prop-types';

import { Th } from './css';

const TableHeader = ({ heading, keys, data, onClick, sortIndex, sortIcon }) => {
  const style = {
    backgroundColor: 'rgb(75, 40, 109)',
    color: '#fff',
    fontSize: '20px',
    padding: '10px'
  };
  const width = 100 / keys.length + 1;

  return (
    <thead>
      <tr>
        <td colSpan={keys.length + 1} style={style}>
          {heading}
        </td>
      </tr>
      <tr>
        {/* <Th width={width}>#</Th> */}
        {keys.map((k, index) => {
          const key = `header${index}`;
          const icon = sortIndex === k ? sortIcon : '';
          const attributes = { key, width };
          if (onClick) attributes.onClick = () => onClick(k);

          return <Th {...attributes}>{`${data[k]} ${icon}`}</Th>;
        })}
      </tr>
    </thead>
  );
};

TableHeader.propTypes = {
  heading: PropTypes.string.isRequired,
  keys: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.objectOf(PropTypes.string).isRequired,
  onClick: PropTypes.func,
  sortIndex: PropTypes.string,
  sortIcon: PropTypes.string
};

TableHeader.defaultProps = {
  onClick: null,
  sortIndex: null,
  sortIcon: null
};

export default TableHeader;
